import { React, UseState, UseEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PageContent from 'layouts/PageContent';
import Drivers from './Drivers';

const DriversScreen = (props) => {
  const {t, i18n} = useTranslation(['salesPerformance', 'common']);
  
  return (
    <PageContent title={t('salesPerformance:Drivers')}>
      <Drivers />
    </PageContent>
  )
}

export default DriversScreen;